import { render, staticRenderFns } from "./RoleAssignmentNew.vue?vue&type=template&id=a255a8b6"
import script from "./RoleAssignmentNew.vue?vue&type=script&lang=js"
export * from "./RoleAssignmentNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports